import { Link, useSearchParams } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getAirshipHangar } from "@/api/gameApi"

export default function HangarPage() {
  const [params] = useSearchParams()
  const pointId = params.get("pointId")

  const q = useQuery({
    queryKey: ["airship-hangar"],
    queryFn: getAirshipHangar,
  })

  const hangar = q.data

  return (
    <GameScreenLayout title="Ангар" backTo="/play/map">
      {pointId ? (
        <p className="mb-2 text-xs text-guardians-muted">Точка: {pointId}</p>
      ) : null}
      {q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : hangar ? (
        <p className="text-sm">
          {hangar.name} · радиус {hangar.radiusMeters} м
        </p>
      ) : (
        <p className="text-sm text-guardians-muted">Ангар не найден в городе</p>
      )}
      <Link
        to="/play/airship"
        className="mt-4 inline-block text-guardians-accent underline"
      >
        Управление дирижаблем →
      </Link>
    </GameScreenLayout>
  )
}
